import { Component, Inject, OnInit } from '@angular/core'
import { DialogService } from '../../services/dialog.service'
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog'
import { IDialog } from '../../directives/dialog.directive'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { RestrictedProductService } from '../../../core/restricted-product/services/restricted-product.service'
import { UserService } from '../../services/user.service'
import { Organization } from '../../shared.interfaces'
import { BehaviorSubject } from 'rxjs'
import { ActionResultDialogComponent } from '../../dialogs/action-result-dialog/action-result-dialog.component'

@Component({
  selector: 'restricted-product-support-ticket-request-modal',
  templateUrl: './support-ticket-request-modal.component.html',
  styleUrls: ['./support-ticket-request-modal.component.scss'],
  standalone: false,
})
export class SupportTicketRequestModalComponent implements OnInit, IDialog<any> {
  // data: any

  processingTicketSubmission = false

  descriptionContent
  error: string
  userName: string
  userEmail: string
  userRole: string
  currentOrganization: Organization[] = []

  saving$ = new BehaviorSubject<boolean>(false)

  filesToUpload = []

  ticketForm = new FormGroup({
    accountName: new FormControl(''),
    accountNumber: new FormControl(''),
    priority: new FormControl(''),
    // phoneNumber: new FormControl(''),
    requesterEmail: new FormControl('', Validators.required),
    requesterName: new FormControl('', Validators.required),
    subject: new FormControl('', Validators.required),
    description: new FormControl('', Validators.required),
  })

  constructor(
    public dialogService: DialogService,
    private dialog: MatDialog,
    private restrictedProductService: RestrictedProductService,
    private userService: UserService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  /* istanbul ignore next */
  ngOnInit(): void {
    if (this.data !== null) {
      this.ticketForm.patchValue({ accountName: this.data.name })
      this.ticketForm.patchValue({ accountNumber: this.data.accountNumber })
      this.ticketForm.controls['accountName'].disable()
      this.ticketForm.controls['accountNumber'].disable()
    }
    // this.ticketForm.patchValue({ permissionLevel: '' })
    this.userName = this.userService.user.firstName + ' ' + this.userService.user.lastName
    this.userEmail = this.userService.user.email
    this.ticketForm.patchValue({ requesterName: this.userName })
    this.ticketForm.patchValue({ requesterEmail: this.userEmail })
  }

  /* istanbul ignore next */
  close() {
    this.dialog.closeAll()
  }

  uploadAttachment(file) {
    this.filesToUpload = file
  }

  removeFile() {
    this.filesToUpload = []
  }

  /* istanbul ignore next */
  submit() {
    this.processingTicketSubmission = true
    this.saving$.next(true)
    const ticketInfo = {
      AccountName: this.ticketForm.get('accountName').value,
      AccountNumber: this.ticketForm.get('accountNumber').value,
      Priority: this.ticketForm.get('priority').value,
      RequesterEmail: this.ticketForm.get('requesterEmail').value,
      RequesterName: this.ticketForm.get('requesterName').value,
      Subject: this.ticketForm.get('subject').value,
      Description: this.ticketForm.get('description').value,
      FormFile: this.filesToUpload,
      // PhoneNumber: this.ticketForm.get('phoneNumber').value
    }

    this.restrictedProductService.submitSupportTicket(ticketInfo).subscribe(
      () => {
        this.processingTicketSubmission = false
        this.saving$.next(false)
        this.close()
        this.dialog.open(ActionResultDialogComponent, {
          panelClass: 'phx-dialog-container',
          autoFocus: true,
          data: {
            success: true,
            result: 'Submitted',
            message: `Your ticket has been submitted.`,
            buttonTxt: 'Close',
          },
        })
      },
      (err) => {
        this.processingTicketSubmission = false
        this.saving$.next(false)
        if (err.status === 400) {
          this.error = err.error.message
        } else {
          this.dialogService.close(null)
        }
      },
    )
  }
}
